let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("leWxW")).then(() => parcelRequire('5b9wX'));